module.exports = __webpack_public_path__ + "static/ART_LOGO_Primary_H-425acbd4d79b7f3675894fe6ccd7b042.svg";